import type { Language } from '../types';
import { getTranslation } from './translations';

const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

export function formatRelativeTime(iso: string, language?: Language, now = Date.now()): string {
    const t = (key: Parameters<typeof getTranslation>[1]) => getTranslation(language, key);
    const then = new Date(iso).getTime();
    if (Number.isNaN(then)) return t('timeJustNow');

    const diffMs = Math.max(0, now - then);
    if (diffMs < MINUTE_MS) return t('timeJustNow');
    if (diffMs < HOUR_MS) {
        const minutes = Math.floor(diffMs / MINUTE_MS);
        return minutes === 1 ? t('timeMinuteAgo') : t('timeMinutesAgo').replace('{n}', String(minutes));
    }
    if (diffMs < DAY_MS) {
        const hours = Math.floor(diffMs / HOUR_MS);
        return hours === 1 ? t('timeHourAgo') : t('timeHoursAgo').replace('{n}', String(hours));
    }
    const days = Math.floor(diffMs / DAY_MS);
    return days === 1 ? t('timeDayAgo') : t('timeDaysAgo').replace('{n}', String(days));
}
